/**
 * Настройки → Проекты (docs/08-screens.md).
 *
 * Справочник синхронизирован с полем «Продукт» в Notion. Названия правятся
 * там, здесь только чтение: новое значение в Notion создаёт проект само.
 */
import { Card } from '@/ds';
import { EmptyState } from '@/components/EmptyState';
import { Provenance } from '@/components/money';
import { useProjects } from '@/api/hooks';
import { plural } from '@/lib/format';
import { QueryState } from '@/components/QueryState';

export function ProjectsTab() {
  const projects = useProjects();
  const rows = projects.data?.projects ?? [];

  if (projects.isLoading || projects.isError) {
    return <QueryState query={projects} what="справочник" />;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-5)' }}>
      <p
        style={{
          font: '400 13px/1.5 var(--font-text)',
          color: 'var(--text-muted)',
          maxWidth: 620,
        }}
      >
        Продукты приходят из поля «Продукт» базы задач. Переименовать их можно только в Notion:
        здесь справочник доступен на чтение. Новое значение в Notion создаёт проект автоматически
        при следующей синхронизации.
      </p>

      {rows.length === 0 ? (
        <EmptyState
          icon="FolderTree"
          title="Справочник пуст"
          description="Проекты появятся после первой синхронизации задач из Notion."
        />
      ) : (
        <Card padding="md">
          <div className="kj-scroll-x">
            <table className="kj-table">
              <thead>
                <tr>
                  <th>Продукт</th>
                  <th>Значение в Notion</th>
                  <th>Задач</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((project) => (
                  <tr key={project.id}>
                    <td data-label="Продукт" style={{ color: 'var(--text-strong)', fontWeight: 500 }}>{project.name}</td>
                    <td data-label="Значение в Notion" className="kj-mono">{project.notionOptionName}</td>
                    <td data-label="Задач" className="kj-mono">{project.taskCount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: 'var(--space-4)' }}>
            <Provenance>
              {`${rows.length} ${plural(rows.length, 'продукт', 'продукта', 'продуктов')} в справочнике`}
            </Provenance>
          </div>
        </Card>
      )}
    </div>
  );
}
